
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ff6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ff6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lUqp4", function(module, exports) {

$parcel$export(module.exports, "trackGearEvent", () => $ff334f1dea0b03d9$export$e8e6f820c6bc0ced);
$parcel$export(module.exports, "installGearNavigationTracking", () => $ff334f1dea0b03d9$export$1e00a1666045f2fb);
// The existing GTM-K2JH98K5 container loads this Google tag. Do not load or
// configure another tag here. Verified against the public container 2026-10-03.
const $ff334f1dea0b03d9$export$621d64bf087f295a = 'G-K7VZ640RSR';
function $ff334f1dea0b03d9$export$e8e6f820c6bc0ced(name, parameters = {}) {
    const send = ()=>{
        try {
            window.dataLayer = window.dataLayer || [];
            // Google tag commands work even when GTM does not expose window.gtag.
            // Arguments objects are the documented gtag queue format; no manual
            // page_view and no duplicate object-event transport.
            function queue() {
                window.dataLayer.push(arguments);
            }
            queue('event', name, {
                ...parameters,
                send_to: $ff334f1dea0b03d9$export$621d64bf087f295a
            });
        } catch  {
        // Blocking analytics must never break navigation or category controls.
        }
    };
    // The GTM Google tag must configure its destination before receiving event
    // commands. Async tag scripts participate in the document load lifecycle.
    // Waiting for load avoids a race on fast cached HTML / slow tag downloads.
    if (document.readyState === 'complete') send();
    else try {
        window.addEventListener('load', send, {
            once: true
        });
    } catch  {}
}
const $ff334f1dea0b03d9$var$NAVIGATION_KEY = 'sfpdcalls:gear-navigation';
function $ff334f1dea0b03d9$var$navigationParameters(link) {
    return {
        direction: link.dataset.gearNavigation === 'gear' ? 'to_prod' : 'to_map',
        page_path: link.dataset.gearNavigation === 'gear' ? '/' : '/prod',
        destination_path: link.dataset.gearNavigation === 'gear' ? '/prod' : '/'
    };
}
function $ff334f1dea0b03d9$var$recordNavigation(event, link) {
    const parameters = $ff334f1dea0b03d9$var$navigationParameters(link);
    // A same-tab click can unload before GTM finishes loading. Hand off its
    // small, fixed record to the destination instead of delaying navigation.
    const sameTab = event.type === 'click' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
    if (sameTab) try {
        window.sessionStorage.setItem($ff334f1dea0b03d9$var$NAVIGATION_KEY, JSON.stringify({
            ...parameters,
            created_at: Date.now()
        }));
        return;
    } catch  {}
    $ff334f1dea0b03d9$export$e8e6f820c6bc0ced('prod_internal_navigation', {
        ...parameters,
        navigation_stage: 'activation'
    });
}
function $ff334f1dea0b03d9$var$consumeNavigation() {
    try {
        const record = JSON.parse(window.sessionStorage.getItem($ff334f1dea0b03d9$var$NAVIGATION_KEY));
        window.sessionStorage.removeItem($ff334f1dea0b03d9$var$NAVIGATION_KEY);
        if (!record) return;
        const validDirection = record.direction === 'to_prod' || record.direction === 'to_map';
        const destination = record.direction === 'to_prod' ? '/prod' : '/';
        const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
        const age = Date.now() - record.created_at;
        if (!validDirection || record.destination_path !== destination || currentPath !== destination || !Number.isFinite(age) || age < 0 || age > 300000) return;
        $ff334f1dea0b03d9$export$e8e6f820c6bc0ced('prod_internal_navigation', {
            direction: record.direction,
            page_path: record.direction === 'to_prod' ? '/' : '/prod',
            destination_path: destination,
            navigation_stage: 'arrival'
        });
    } catch  {}
}
function $ff334f1dea0b03d9$export$1e00a1666045f2fb(root = document) {
    $ff334f1dea0b03d9$var$consumeNavigation();
    const handler = (event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        const link = event.target.closest?.('a[data-gear-navigation]');
        if (link) $ff334f1dea0b03d9$var$recordNavigation(event, link);
    };
    root.addEventListener('click', handler);
    root.addEventListener('auxclick', handler);
}

});


var $lUqp4 = parcelRequire("lUqp4");
const $8117eb58c1673dc4$var$cards = [
    ...document.querySelectorAll('.product-card')
];
const $8117eb58c1673dc4$var$sections = [
    ...document.querySelectorAll('[data-category-section]')
];
const $8117eb58c1673dc4$var$controls = document.querySelector('.category-controls');
const $8117eb58c1673dc4$var$filters = [
    ...$8117eb58c1673dc4$var$controls.querySelectorAll('[data-filter]')
];
function $8117eb58c1673dc4$var$filterCategory(category, track = true) {
    $8117eb58c1673dc4$var$sections.forEach((section)=>{
        section.hidden = category !== 'all' && section.dataset.categorySection !== category;
    });
    $8117eb58c1673dc4$var$filters.forEach((button)=>{
        button.setAttribute('aria-pressed', String(button.dataset.filter === category));
    });
    const count = $8117eb58c1673dc4$var$cards.filter((card)=>category === 'all' || card.dataset.category === category).length;
    const label = $8117eb58c1673dc4$var$filters.find((button)=>button.dataset.filter === category).textContent;
    document.getElementById('product-count').textContent = `${count} recommendations${category === 'all' ? '' : ` in ${label}`}`;
    if (track) (0, $lUqp4.trackGearEvent)('product_category_select', {
        category: label,
        page_path: '/prod'
    });
}
$8117eb58c1673dc4$var$controls.addEventListener('click', (event)=>{
    const button = event.target.closest('button[data-filter]');
    if (button) $8117eb58c1673dc4$var$filterCategory(button.dataset.filter);
});
$8117eb58c1673dc4$var$controls.hidden = false;
// Featured anchors and direct product fragments always reveal their destination,
// even after the visitor has filtered another category.
function $8117eb58c1673dc4$var$revealFragment() {
    const target = document.getElementById(window.location.hash.slice(1));
    if (target?.classList.contains('product-card') && target.closest('section').hidden) $8117eb58c1673dc4$var$filterCategory('all', false);
    return target;
}
document.querySelectorAll('[data-featured-link]').forEach((link)=>link.addEventListener('click', ()=>$8117eb58c1673dc4$var$filterCategory('all', false)));
window.addEventListener('hashchange', ()=>{
    const target = $8117eb58c1673dc4$var$revealFragment();
    target?.scrollIntoView({
        block: 'start'
    });
});
$8117eb58c1673dc4$var$revealFragment();
function $8117eb58c1673dc4$var$trackProduct(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest('a[data-product-link]');
    if (!link) return;
    const card = link.closest('.product-card');
    const visibleCards = $8117eb58c1673dc4$var$cards.filter((item)=>!item.closest('[data-category-section]').hidden);
    const destination = new URL(link.href);
    const asin = destination.hostname === 'www.amazon.com' && destination.pathname.match(/\/dp\/([A-Z0-9]{10})/);
    // Only the catalog destination is sent, never incoming query strings,
    // map/CAD state, user identifiers, or a referrer URL.
    (0, $lUqp4.trackGearEvent)('product_click', {
        product_id: card.dataset.productId,
        product_name: card.dataset.productName,
        product_category: card.dataset.productCategory,
        product_position: visibleCards.indexOf(card) + 1,
        destination_domain: destination.hostname,
        // GA4 string parameters have a length limit. Report the canonical product
        // destination, keeping affiliate/campaign queries on the actual link only.
        destination_url: asin ? `https://www.amazon.com/dp/${asin[1]}` : `${destination.origin}${destination.pathname}`,
        affiliate: card.dataset.affiliate === 'true',
        page_path: '/prod'
    });
}
document.addEventListener('click', $8117eb58c1673dc4$var$trackProduct);
document.addEventListener('auxclick', $8117eb58c1673dc4$var$trackProduct);
document.querySelectorAll('[data-product-image]').forEach((image)=>{
    const show = ()=>{
        if (image.naturalWidth > 0) image.classList.add('is-loaded');
    };
    image.addEventListener('load', show);
    image.addEventListener('error', ()=>image.remove());
    if (image.complete) {
        if (image.naturalWidth > 0) show();
        else image.remove();
    }
});
document.querySelectorAll('[data-copyright-year]').forEach((element)=>{
    element.textContent = new Date().getFullYear();
});
(0, $lUqp4.installGearNavigationTracking)();
(0, $lUqp4.trackGearEvent)('prod_view', {
    page_path: '/prod',
    page_title: document.title
});


//# sourceMappingURL=prod.8b37631e.js.map
